/* Meridian — looping demo videos pause when off screen; slider drag. */
(function () {
  function loops() {
    var vids = document.querySelectorAll('video.mrd-loop');
    if (!vids.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) {
      io.observe(v);
      v.addEventListener('click', function () { v.paused ? v.play() : v.pause(); });
    });
  }
  function sliders() {
    var REVEAL_DELAY = 650;   // let the section settle before it moves
    var DURATION     = 1450;
    var OVERSHOOT    = 1.70158; // dips ~6.5 points past the rest point, then settles

    document.querySelectorAll('[data-mrd-cmp]').forEach(function (c) {
      var input = c.querySelector('.mrd-cmp__input');
      if (!input) return;
      var rest = parseFloat(c.getAttribute('data-mrd-rest'));
      if (isNaN(rest)) rest = 35;

      var pending = null;
      var set = function (v) {                    /* batched: one write per paint */
        if (pending !== null) { pending = v; return; }
        pending = v;
        requestAnimationFrame(function () {
          c.style.setProperty('--x', pending + '%');
          pending = null;
        });
      };
      input.addEventListener('input', function (e) { set(e.target.value); });

      /* start fully on the "without" frame, then reveal */
      c.style.setProperty('--x', '100%');
      input.value = 100;

      var played = false;
      var reduced = window.matchMedia &&
                    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ease-out-back: overshoots the target, then settles onto it */
      var c1 = OVERSHOOT, c3 = c1 + 1;
      var ease = function (t) { var p = t - 1; return 1 + c3 * p * p * p + c1 * p * p; };

      var play = function () {
        if (played) return;
        played = true;
        if (reduced) { c.style.setProperty('--x', rest + '%'); input.value = rest; return; }
        var t0 = null;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var t = Math.min(1, (ts - t0) / DURATION);
          c.style.setProperty('--x', (100 + (rest - 100) * ease(t)) + '%');
          if (t < 1) requestAnimationFrame(step);
          else input.value = rest;
        };
        requestAnimationFrame(step);
      };

      /* if they grab it first, the animation never fires */
      input.addEventListener('pointerdown', function () { played = true; });

      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); setTimeout(play, REVEAL_DELAY); }
          });
        }, { threshold: 0.45 });
        io.observe(c);
      } else { play(); }
    });
  }
  function tagSync() {
    document.querySelectorAll('.mrd-split__tag').forEach(function (tag) {
      var media = tag.closest('.mrd-split__media');
      var video = media && media.querySelector('video.mrd-loop');
      var from = tag.querySelector('.mrd-split__tag-word--from');
      var to = tag.querySelector('.mrd-split__tag-word--to');
      if (!video || !from || !to || tag.dataset.mrdTagSynced) return;
      tag.dataset.mrdTagSynced = '1';

      var WINDOW = 0.04; // fraction of the video's duration on each side of the midpoint the snap occupies
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function ease(t) { return 1 - Math.pow(1 - t, 4); } // snappy: fast start, quick settle

      function setWord(el, t) {
        // t: 0 = fully emphasized, 1 = fully dimmed/receded.
        // transform-origin (set in CSS) anchors each word at the edge closest
        // to the arrow, so scaling only grows/shrinks it outward — never
        // shifts it up, down, closer, or further from the arrow.
        el.style.opacity = 1 + (0.45 - 1) * t;
        el.style.transform = 'scale(' + (1 + (0.85 - 1) * t) + ')';
      }

      function frame() {
        if (!video.duration || video.paused) { requestAnimationFrame(frame); return; }
        var phase = (video.currentTime / video.duration) % 1;
        // Switch point sits 1s after the video's midpoint, not on it — loop
        // length still matches the video exactly either way.
        var center = (video.duration / 2 + 1) / video.duration;
        var t;
        if (reduced) {
          t = phase < center ? 0 : 1;
        } else if (phase < center - WINDOW) {
          t = 0;
        } else if (phase > center + WINDOW) {
          t = 1;
        } else {
          t = ease((phase - (center - WINDOW)) / (2 * WINDOW));
        }
        setWord(from, t);
        setWord(to, 1 - t);
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }
  function init() { loops(); sliders(); tagSync(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
